import { AsyncPipe, DatePipe, UpperCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AssetDto, AssetVersionDto } from '@nusign/picflow-backend-types';
import { BadgeComponent } from '../../../components/badge/badge.component';
import { AssetVersionUrlPipe } from '../../../shared/pipes/asset-version-url.pipe';

@Component({
  selector: 'app-asset-version-compare-menu',
  templateUrl: './asset-version-compare-menu.component.html',
  styleUrls: ['./asset-version-compare-menu.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [UpperCasePipe, DatePipe, AssetVersionUrlPipe, AsyncPipe, BadgeComponent],
})
export class AssetVersionCompareMenuComponent implements OnInit {
  @Input() asset: AssetDto;
  @Input() versions: AssetVersionDto[];
  @Input() selectedVersion: AssetVersionDto;
  @Input() otherSelectedVersion: AssetVersionDto;
  @Output() onSelect = new EventEmitter();
  names: { [versionId: string]: { name: string; ext: string } };

  async ngOnInit() {
    this.names = {};
    this.versions.sort((a, b) => (a.created_at > b.created_at ? -1 : 1));
    this.versions.forEach(v => (this.names[v.id] = this.calcName(v)));
  }

  private calcName(version: AssetVersionDto) {
    const name = version.asset_name.split('.');
    const ext = name.pop();
    return {
      name: name.join('.'),
      ext,
    };
  }
}
